<template>
  <span v-if="wetResource">
    <v-btn icon @click="dialog = true" v-if="wetResource">
      <v-icon v-if="createNew">add</v-icon>
      <v-icon v-else>edit</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" v-if="dialog" max-width="900px" :modal="true">
      <v-form @submit.prevent="saveResource" :disabled="$attrs.disabled">
        <v-card :loading="loading">
          <v-card-title class="headline" v-if="createNew"
            >Create New {{ resourceLabel }}
          </v-card-title>
          <v-card-title class="headline" v-else
            >Edit {{ resourceLabel }}
          </v-card-title>
          <v-card-text>
            <slot
              :item="wetResource"
              :resource="wetResource"
              @delete="$emit('delete', $event)"
            >
              {{ wetResource }}
            </slot>
          </v-card-text>

          <v-card-actions>
            <div class="" v-if="!createNew">
              <span class="caption italics">
                Created: {{ wetResource.createdby }}
                {{ wetResource.datecreated | formatDate }} | Updated:
                {{ wetResource.updatedby }}
                {{ wetResource.dateupdated | formatDate }}
                <br />
                <small>
                  <em>
                    ({{ resourceLabel }} #{{ wetResource[resourceIdField] }})
                  </em>
                </small>
              </span>
            </div>
            <v-spacer></v-spacer>
            <error-messages v-if="!success" :errors="errors" />
            <v-fade-transition transition="fade">
              <v-icon v-show="success">check</v-icon>
            </v-fade-transition>
            <v-btn color=" primary" type="submit" :disabled="loading">
              <v-progress-circular indeterminate v-show="loading" />
              <span v-show="!loading">
                <span v-if="createNew">Create</span> <span v-else>Save</span>
              </span>
            </v-btn>
            <v-btn @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </span>
</template>

<script>
import moment from "moment";
// import resourceSelect from "../resource-select";
import ScopeSelect from "../register/scopes/scope-select";
import lbSelect from "@/components/lib/lb-select";

export default {
  name: "editResourceButton",
  data() {
    return {
      dialog: false,
      linkToresourceId: null,
      loading: false,
      success: false,
      errors: [],
      origResource: {},
      wetResource: {}
    };
  },
  props: {
    resource: {
      type: Object,
      required: false,
      default: function() {
        return {};
      }
    },
    resourceId: {
      type: [Number, Array],
      required: false
    },
    resourceIdField: {
      type: String,
      required: false,
      default: "id"
    },
    resourceLabel: {
      type: String,
      required: false,
      default: "Resource"
    },
    resourceName: {
      type: String,
      required: true,
      default: "Resource"
    },
    resourceUrl: {
      type: String,
      required: false,
      default(value) {
        console.debug("props:", value, this);
        // return false;
        return value ? value : this.resourceName;
      }
    },
    filter: {
      type: Object,
      required: false
    },
    createNew: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    resource: {
      immediate: true,
      handler(newVal) {
        if (!this.loading) {
          this.wetResource = { ...newVal };
        }
      }
    }
  },
  methods: {
    async saveResource() {
      this.loading = true;
      this.success = false;
      try {
        if (!this.createNew) {
          if (Array.isArray(this.resourceId)) {
            let where = {};
            for (let field of this.resourceId) {
              if (!this.origResource[field]) {
                throw new Error(
                  "incomplete-composite-id",
                  "Unable to update resource with composite id because all parts of the ID were not supplied"
                );
              }
              where[field] = this.origResource[field];
            }

            if (!where) {
              return false;
            }

            var result = await this.$http.post(
              `/${this.resourceUrl}/update`,
              this.wetResource,
              {
                params: { where, limit: 1 }
              }
            );
          } else {
            var result = await this.$http.patch(
              `/${this.resourceUrl}/`,
              this.wetResource,
              {
                params: { limit: 1 }
              }
            );
          }
        } else {
          var result = await this.$http.post(
            `/${this.resourceUrl}/`,
            this.wetResource
          );
        }

        if (result) {
          this.origResource = this.wetResource; //copy the current one after  updating
          this.wetResource = { ...result.data };

          this.errors = [];
          this.success = true;
          this.$emit("save", this.resource);
          // setTimeout(() => {
          //   this.dialog = false;
          // }, 300);
        }
      } catch (e) {
        this.handleError(e);
      }
      this.loading = false;
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  created() {
    if (this.createNew) {
      this.resource = { ...this.resource };
    }

    this.origResource = { ...this.resource };
  }
};
</script>

<style></style>
